import { COLUMN_CODE, TableManger, TABLES } from "./TableManger";
import { INPUT_TYPE,showLoader,removeLoader } from "deskera-ui-library";
import Utility, { deepClone } from "../utility/Utility";
import Table from "../services/table";
export default class ContactManager {
    static getDefaultValues(values = {}) {
        return {
            [TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)]: [0],
            [TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS)]: [0],

            ...values
        }
    }
    static getDataToUpdate = (data) => {
        let contactColumns = {};
        TableManger.getTableColumns(TABLES.CANDIDATE).forEach(column => {
            if (column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT) {
                contactColumns[column.id] = column;
            }
        });
        Object.keys(contactColumns).forEach(item => {
            if (data[item]) {
                data[item] = data[item].map(r => contactColumns[item].options.findIndex(op => op.id === r));
            }
        })
    }
    static getDataToUpdateForCandidate = (data, columns) => {
        let contactColumns = {};
        columns.forEach(column => {
            if (column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT) {
                contactColumns[column.id] = column;
            }
        });
        Object.keys(contactColumns).forEach(item => {
            if (data[item]) {
                data[item] = data[item].map(r => contactColumns[item].options.findIndex(op => op.id === r));
            }
        })
    }
    static getFilterPayload=(payload)=>{
        payload = deepClone(payload)
        const jobPipelineId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_PIPELINE_ID);
        const jobOpeningId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
        
        const jobStageId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOB_STAGE_ID);
        const statusId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
    
        let jobOpeningValues = [];
        let jobPipelineValues = [];
    
        let statusValues = [];
        let jobStageValues = [];
        
        if(payload?.conditions) {
          payload.conditions.forEach(condition=>{
            if(condition && condition.colId === jobOpeningId && Array.isArray(condition.value)) {
              jobOpeningValues = [...jobOpeningValues, ...condition.value.filter(v=> typeof v === "number")]
              jobPipelineValues = [...jobPipelineValues, ...condition.value.filter(v=> typeof v !== "number")]
            }
    
            if(condition && condition.colId === statusId) {
              statusValues = [...statusValues, ...condition.value.filter(v=> typeof v === "number")]
              jobStageValues = [...jobStageValues, ...condition.value.filter(v=> typeof v !== "number")]
            }
          })
    
          // now replace 
          if (jobOpeningValues && jobOpeningValues.length > 0) {
            payload.conditions.forEach(condition => {
              if (condition.colId === jobOpeningId) {
                condition.value = jobOpeningValues
              }
            })
          } else {
            payload.conditions = payload.conditions.filter(c=>c.colId !== jobOpeningId)
          }
    
          if (jobPipelineValues && jobPipelineValues.length > 0) {
            let newCondition = [{
              colId: jobPipelineId,
              opr: "c",
              value: jobPipelineValues
            }]
            payload.conditions = [...payload.conditions, ...newCondition]
          }
    
          // now for status and stage
    
          if (statusValues && statusValues.length > 0) {
            payload.conditions.forEach(condition => {
              if (condition.colId === statusId) {
                condition.value = statusValues
              }
            })
          } else {
            payload.conditions = payload.conditions.filter(c=>c.colId !== statusId)
          }
    
          if (jobStageValues && jobStageValues.length > 0) {
            let newCondition = [{
              colId: jobStageId,
              opr: "c",
              value: jobStageValues
            }]
            payload.conditions = [...payload.conditions, ...newCondition]
          }
        }
        return payload
      }

    static deleteAttachmentAPI=(path,tableName,attachment,tableId, action)=> {
    
      let attachmentColID = TableManger.getColumnId(
        tableName,
        COLUMN_CODE.CANDIDATE.DOCUMENT
      );
      
      let attachments = Utility.decodeJSON(attachment[attachmentColID])
      
      attachments.splice(path.index,1);
      const dataToUpdate= {
        [attachmentColID]: Utility.encodeJSON(attachments)
      } 
      showLoader()
      Table.updateRecord(
        dataToUpdate,
        attachment.id,
        tableId
      ).then((data) => {
        action.getDealDetail()
        
      },error=>{
        removeLoader()
      });
    }
}